module.exports = __webpack_public_path__ + "promo/app-store-badges/apple-app-store-fr-5f41343a9ebcd5412b2fa1b06826f78e.svg";


//////////////////
// WEBPACK FOOTER
// ./images/promo/app-store-badges/apple-app-store-fr.svg
// module id = WOoQ
// module chunks = 20